import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { useTransition, animated } from "react-spring"
import { useHover } from "react-use-gesture"

// Import Common Components
import { PrismicImage, Button, ButtonLink } from "../common"

// Styles
const StyledDeskNav = styled.nav`
  display: none;
  justify-content: space-between;
  align-items: center;
  > ${Button} {
    margin-top: 0;
  }
  @media ${(props) => props.theme.breakpoints.large} {
    display: flex;
  }
`
const StyledNavLink = styled(Link)`
  color: var(--color);
  margin-right: 2rem;
  font-weight: 700;
`
const StyledSubNavLink = styled(Link)`
  display: flex;
  align-items: center;
  color: #000;
  font-weight: 600;
  font-size: 14px;
  padding: 1rem 0;
  border-bottom: 1px solid #dedede;
  > img,
  .gatsby-image-wrapper {
    width: 45px !important;
    margin-right: 0.8rem;
  }
  ${(props) =>
    props.feature &&
    `
    font-size: 18px;
    display: flex;
    justify-content: center;
    border-bottom: none;
    color: ${props.theme.colors.brandColor};
  `}
`

const StyledSubNav = styled.div`
  position: relative;
  > div {
    border-top: 25px solid transparent;
    left: 50%;
    position: absolute;
  }
  > span {
    cursor: pointer;
  }
  nav {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
    padding: 1rem 1rem;
    border-radius: 0.8rem;
    min-width: 500px;
    background: #fff;
    position: relative;
    &:before {
      content: "";
      display: block;
      height: 20px;
      width: 20px;
      background-color: #fff;
      border: inherit;
      position: absolute;
      top: -10px;
      left: calc(50% - 28px);
      clip-path: polygon(100% 100%, 0% 100%, 0% 0%);
      border-radius: 0 0 0 0.3rem;
      transform: rotate(135deg);
    }
  }
`

const SubNav = ({ nav_title, page_reference }) => {
  const { nav_items } = page_reference.document.data
  const [active, setActive] = useState(false)
  const bind = useHover(({ hovering }) => setActive(hovering))

  const transitions = useTransition(active, null, {
    from: { opacity: 0, transform: "translate3d(-50%, -2%, 0)" },
    enter: { opacity: 1, transform: "translate3d(-50%, 0%, 0)" },
    leave: { opacity: 0, transform: "translate3d(-50%, -2%, 0)" },
  })
  return (
    <StyledSubNav {...bind()}>
      <StyledNavLink as="span">{nav_title}</StyledNavLink>
      {transitions?.map(({ item, key, props }) => {
        return item ? (
          <animated.div
            key={`transitions-${key}`}
            style={{ ...props, pointerEvents: active ? "all" : "none" }}
          >
            <nav>
              {nav_items?.map((item, index) => {
                const { nav_title, icon, feature_link, page_reference } = item
                const isFeature = feature_link === "true"
                return (
                  <StyledSubNavLink
                    key={`navItem-${index}`}
                    to={page_reference?.url}
                    feature={isFeature}
                  >
                    <PrismicImage {...icon} />
                    {nav_title}
                  </StyledSubNavLink>
                )
              })}
            </nav>
          </animated.div>
        ) : null
      })}
    </StyledSubNav>
  )
}

export const DeskNav = ({ items }) => {
  return (
    <StyledDeskNav>
      {items.map((item, index) => {
        const { type, url } = item.page_reference
        return type === "sub_navigation" ? (
          <SubNav key={`DeskSubNav-${index}`} {...item} />
        ) : (
          <StyledNavLink key={`DeskNavLink-${index}`} to={url}>
            {item.nav_title}
          </StyledNavLink>
        )
      })}
      <Button
        as="a"
        href="https://go.mytrev.com/account/login"
        target="_blank"
        className="login-button"
      >
        Login
      </Button>
      <ButtonLink
        to="/signup"
        href="https://www.mytrev.com/signup"
        className="demo-button"
        state={{ subject: "Free Demo" }}
      >
        Free Demo
      </ButtonLink>
    </StyledDeskNav>
  )
}
